import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { map } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { StatGroupComponent, StatItem } from '../../../components/stat-group/stat-group.component';
import { TabCounts } from '../requirements.types';

@Component({
  selector: 'app-requirements-stats-bar',
  imports: [StatGroupComponent],
  templateUrl: './requirements-stats-bar.component.html',
  styleUrl: './requirements-stats-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RequirementsStatsBarComponent {
  private readonly translate = inject(TranslateService);

  private readonly currentLang = toSignal(this.translate.onLangChange.pipe(map((e) => e.lang)), {
    initialValue: this.translate.currentLang,
  });

  tabCounts = input.required<TabCounts>();

  readonly stats = computed((): StatItem[] => {
    this.currentLang();
    const c = this.tabCounts();
    return [
      { label: this.translate.instant('requirements.stats.total'), value: c.total },
      {
        label: this.translate.instant('requirements.stats.open'),
        value: c.offen,
        color: 'var(--to-warn-fg, #92400e)',
      },
      {
        label: this.translate.instant('requirements.stats.done'),
        value: c.fertig,
        color: 'var(--to-green-fg, #15803d)',
      },
    ];
  });
}
